import React from 'react';
import {Modal, ModalHeader, ModalBody} from "../../../../components/Modal";

import { useTranslation } from 'react-i18next';

interface RecipientInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const LeadershipInfoInfoModal = ({ isOpen, onClose }: RecipientInfoModalProps) => {

    const translation = useTranslation();
    const { t, i18n } = translation;

    const isSwedish = i18n.language === 'sv';

    const textPart1 = isSwedish ? 
    'Chef med teamansvar:' :
    'Manager with team responsibility:';

    const textPart2 = isSwedish ?
    'Hanterar samarbete och operativa mål.' :
    'Managing collaboration and operational goals.';

    const textPart3 = isSwedish ?
    'Chef med personalansvar:' :
    'Manager with personnel responsibility:';

    const textPart4 = isSwedish ?
    'Övervakar rekrytering, prestanda och karriär.' :
    'Overseeing hiring, performance, and careers.';

    const textPart5 = isSwedish ?
    'C-nivå chef:' :
    'C-level executive:';

    const textPart6 = isSwedish ?
    'Hanterar beslut på hög nivå.' :
    'Managing high-level decision-making.';
    
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader onClose={onClose}>
                <div className="z-title1">{t('leadership-levels')}</div>
            </ModalHeader>
            <ModalBody>
                <>
                    <p className="z-title2">{textPart1}</p>
                    <p className="z-body2">{textPart2}</p>
                    <br/>
                    <p className="z-title2">{textPart3}</p>
                    <p className="z-body2">{textPart4}</p>
                    <br/>
                    <p className="z-title2">{textPart5}</p>
                    <p className="z-body2">{textPart6}</p>
                </>
            </ModalBody>
        </Modal>
    );
};

export default LeadershipInfoInfoModal;